import { isSuperChainSelector } from 'selectors';

import DashboardWidgetController from 'dashboard/components/dashboard-widget/dashboard-widget-controller';

import { checkAccess } from 'app/actions/app.actions';
import { fetchNetSalesSummary } from 'dashboard/actions/net-sales/net-sales-summary.actions';
import { setActiveTab } from 'utils/actions/active-tab/active-tab.actions';
import template from './net-sales-widget.html';
import tabs from './tabs';

const mapStateToThis = ({ session, netSales, ui, dictionary }) => {
  const { isLoading, netSalesSummary } = netSales;
  const { WTD, MTD, QTD, YTD } = tabs;
  const { activeTab } = ui;
  const { locale } = session;
  const terms = dictionary.terms[locale];
  const { retailer } = session;
  const isSuperChain = isSuperChainSelector({ session });

  return {
    retailer,
    session,
    netSalesSummary,
    isLoading,
    activeTab,
    isSuperChain,
    isEmpty: netSalesSummary.length === 0,
    WTD,
    MTD,
    QTD,
    YTD,
    terms,
  };
};

const mapDispatchToThis = {
  checkAccess,
  fetchNetSalesSummary,
  setActiveTab,
};

// eslint-disable-next-line no-undef
@Inject('$scope', '$ngRedux', '$state')
class NetSalesWidgetController extends DashboardWidgetController {
  constructor() {
    super();
    this.unsubscribe = this.$ngRedux.connect(mapStateToThis, mapDispatchToThis)(this);
  }

  $onInit() {
    const retailerId = this.$state.params.retailerNo || this.retailer.retailerId;
    this.isHistoryLinkVisible = this.checkAccess('net.sales.history') && !this.isSuperChain;
    this.setActiveTab(this.WTD, 'activeTab');
    this.isYear = false;
    this.$scope.$applyAsync(this.fetchNetSalesSummary(retailerId).then(() => {
      this.onChangePeriodYear(this.isYear);
    }));
  }

  $onDestroy() {
    this.setActiveTab('', 'activeTab');
    this.unsubscribe();
  }

  onChangePeriodYear(isYear) {
    this.isYear = isYear;
    if (isYear)
    {
      this.netSalesDelta = this.netSalesSummary[this.activeTab].netSalesDeltaYear;
      this.deltaAsPerc = this.netSalesSummary[this.activeTab].deltaAsPercYear;
    }
    else
    {
      this.netSalesDelta = this.netSalesSummary[this.activeTab].netSalesDeltaPeriod;
      this.deltaAsPerc = this.netSalesSummary[this.activeTab].deltaAsPercPeriod;
    }
  }

}

export default class NetSalesWidgetComponent {
  constructor() {
    this.template = template;
    this.controller = NetSalesWidgetController;
    this.bindings = {
      isEditMode: '<',
      isRemovable: '<',
      removeWidget: '&?',
    };
  }
}



// WEBPACK FOOTER //
// ./src/modules/dashboard/components/dashboard-widget/net-sales/net-sales-widget-component.js